var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "introduction-honour area"
  }, [_vm._m(0), _c("div", {
    staticClass: "honor-carousel"
  }, [_c("div", {
    staticClass: "carousel-left",
    on: {
      click: _vm.handleClickLeft
    }
  }), _c("div", {
    staticClass: "honor-list clearfix",
    style: {
      transform: `translateX(${_vm.translateX}px)`
    }
  }, _vm._l(_vm.honorList, function (item, index) {
    return _c("honour-card", {
      key: index,
      staticClass: "honor-item",
      attrs: {
        img: item
      }
    });
  }), 1), _c("div", {
    staticClass: "carousel-right",
    on: {
      click: _vm.handleClickRight
    }
  })])]);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("section", {
    staticClass: "title"
  }, [_c("h4", {
    staticClass: "puhui-M"
  }, [_vm._v("HONOR")]), _c("h4", {
    staticClass: "puhui-M"
  }, [_vm._v("荣誉资质")])]);
}];
render._withStripped = true;
export { render, staticRenderFns };